import { errorEnvelope } from "@repo/contract";
export class ApiError extends Error {
    status;
    code;
    messageKey;
    params;
    requestId;
    constructor(init) {
        super(`${init.code} (HTTP ${init.status}): ${init.messageKey}`, {
            cause: init.cause,
        });
        this.name = "ApiError";
        this.status = init.status;
        this.code = init.code;
        this.messageKey = init.messageKey;
        this.params = init.params;
        this.requestId = init.requestId;
    }
}
/**
 * Thrown when there is no live session left and the only way forward is a new
 * sign-in. Distinct from {@link ApiError} so a screen can tell "you are signed
 * out" from "the server said no to this particular thing" without matching on
 * a status code.
 */
const SESSION_EXPIRED_MESSAGE = "The session has ended. Sign in again to continue.";
export class SessionExpiredError extends Error {
    constructor(message = SESSION_EXPIRED_MESSAGE, options) {
        super(message, options);
        this.name = "SessionExpiredError";
    }
}
/**
 * Turn a failed response into an {@link ApiError}.
 *
 * A body that is not the envelope — an HTML error page from an intermediary, an
 * empty 502, a captive portal — must still produce something with a usable
 * `messageKey`, because the screen renders that key and "undefined" is not a
 * translation. `error.internal` is the one D27 reserves for it.
 */
export async function toApiError(response) {
    try {
        const parsed = errorEnvelope.safeParse(await response.json());
        if (parsed.success) {
            return new ApiError({ status: response.status, ...parsed.data.error });
        }
    }
    catch (cause) {
        // Not JSON at all. Fall through to the status-derived envelope, keeping
        // the parse failure as `cause` so a log still shows what arrived.
        return internalError(response.status, cause);
    }
    return internalError(response.status);
}
/** The envelope D27 reserves for "the server did not answer in our shape". */
export function internalError(status, cause) {
    return new ApiError({
        cause,
        code: "INTERNAL",
        messageKey: "error.internal",
        status,
    });
}
//# sourceMappingURL=api-error.js.map